<template>
    <div class="row">
        <div class="col">
            <h2 class="titre">Ajout Évaluation</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :evaluation="evaluation" :listeEtats="listeEtats" :listePropos="listePropos"
                    :listeJeux="listeJeux" :liaisonsEvaluation="liaisonsEvaluation"
                    :isModifier="false"/>
    <ButtonBar @fermer="fermer"
               @ajouter="ajouter" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation"/>
    <Toast/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Ajouter/ButtonBarEvaluation.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsEvaluation.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
    components: {
        ButtonBar,
        ModifierChamps,
        DialogConfirmation
    },
    data() {
        return {
            isSauvegardeEnCours: false
        };
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
            evaluation: 'evaluation/evaluation',
            listeEtats: 'evaluation/listeEtats',
            listePropos: 'evaluation/listePropos',
            listeJeux: 'jeux/listeJeux',
            //liaisonsEvaluation: 'evaluation/liaisonMiseEvaluation'
        })
    },
    beforeMount() {
        this.$store.dispatch('evaluation/resetEvaluationStoredAction', {
            cleDossier: this.$route.params.cleDossier,
            siteDossier: this.$route.params.siteDossier
        });

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Ajouter une Evaluation");
        this.$store.dispatch('evaluation/rechercherDefaut48HeuresAction')
                .then(() => {
                    this.isRechercheDataLoading = false;
                });
        this.liaisonsEvaluation = this.evaluation.liaisonMiseEvaluation;
        this.evaluation.creerLe = this.$commun.formatDateForInput(new Date());
    },
    created() {
        setTimeout(this.afficherVerifierSauvegarde, 300000);
    },
    methods: {
        ajouter() {
            this.isSauvegardeEnCours = true;
            this.$store.commit('evaluation/UPDATE_EVALUATION', this.$refs.modifierChamps.getEvaluationLocal());
            this.$store.dispatch('evaluation/ajouterEvaluationAction', {
                cle: this.$route.params.cle,
                site: this.$route.params.site,
            }).then((res) => {
                this.$root.$refs.messagesComp.messagesList = res.data.messages
                if (res?.data?.messages.length == 0) {
                    this.$toast.add(
                            {
                                severity: 'success',
                                summary: 'Ajouter',
                                detail: 'Évaluation ajoutée.',
                                life: 6000
                            });
                    this.$router.push({ name: 'dossierModifier', params: {cle: this.$route.params.cleDossier, site: this.$route.params.siteDossier}});
                }
                this.isSauvegardeEnCours = false;
            });
        },
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        },
        afficherVerifierSauvegarde() {
            this.$toast.add(
                    {
                        severity: 'warn',
                        summary: 'Avertissement Sauvegarde',
                        detail: "N'oubliez pas de sauvegarder régulièrement votre évaluation.",
                        life: 6000
                    });
        }
    },
    beforeRouteLeave(to, from, next) {
        return this.$refs.dialogConfirmation.confirmer(next, this.evaluation, this.$refs.modifierChamps.getEvaluationLocal());
    },
};
</script>
